import * as React from 'react';
import {
    FontAwesomeIcon as FAI,
    FontAwesomeIconProps as RawProps,
} from '@fortawesome/react-fontawesome';
import { classes } from '../../lib';

type FontAwesomeIconProps = RawProps & {
    clickable?: boolean;
    className?: string;
};

export const FontAwesomeIcon = ({
    className,
    clickable,
    style,
    ...props
}: FontAwesomeIconProps): JSX.Element => (
    <span
        style={{ verticalAlign: 'baseline', ...style }}
        className={classes('anticon', clickable ? 'pointer' : '', className)}>
        <FAI {...props} />
    </span>
);
